import request from '@/utils/request'

let SharingApi = {
  /*活动列表*/
    activeList(data) {
    return request._post('/shop/plus.assemble.active/index', data);
  },
  /*添加分类*/
  addCategory(data) {
    return request._post('/shop/plus.sharing.category/add', data);
  },

}
export default SharingApi;



// WEBPACK FOOTER //
// ./src/api/sharing.js